// extracted by css-extract-rspack-plugin
export default {"cls1":"FeedbackPopover-cls1_6dp","cls2":"FeedbackPopover-cls2_iRY FeedbackPopover-cls1_6dp"};